const pageNameKey = "helpButton";

export const helpButtonEn = {
  [pageNameKey]: {
    chatButtonAltText: "Click here to contact us",
    chatButtonText: "Contact",
    faqButtonAltText: "Click here for FAQ",
    faqButtonText: "FAQ",
    needHelp: "Need Help?",
    tooltip: "Help",
    weGotYou: "We got you!",
  },
};

export const helpButtonPtBr = {
  [pageNameKey]: {
    chatButtonAltText: "Clique aqui para entrar em contato conosco",
    chatButtonText: "Contato",
    faqButtonAltText: "Clique aqui para ver as perguntas frequentes",
    faqButtonText: "Perguntas frequentes",
    needHelp: "Precisa de ajuda?",
    tooltip: "Ajuda",
    weGotYou: "Estamos com você!",
  },
};

export const helpButtonDe = {
  [pageNameKey]: {
    chatButtonAltText: "Hier klicken, um uns zu kontaktieren",
    chatButtonText: "Kontakt",
    faqButtonAltText: "Hier klicken für FAQ",
    faqButtonText: "FAQ",
    needHelp: "Brauchen Sie Hilfe?",
    tooltip: "Hilfe",
    weGotYou: "Wir sind für Sie da!",
  },
};

export const helpButtonZhHans = {
  [pageNameKey]: {
    chatButtonAltText: "点击这里联系我们",
    chatButtonText: "联系",
    faqButtonAltText: "点击这里查看常见问题",
    faqButtonText: "常见问题",
    needHelp: "需要帮助吗？",
    tooltip: "帮助",
    weGotYou: "我们为您提供支持！",
  },
};

export const helpButtonIt = {
  [pageNameKey]: {
    chatButtonAltText: "Clicca qui per contattarci",
    chatButtonText: "Contattaci",
    faqButtonAltText: "Clicca qui per FAQ",
    faqButtonText: "FAQ",
    needHelp: "Hai bisogno?",
    tooltip: "Aiuto",
    weGotYou: "Ci pensiamo noi!",
  },
};

export const helpButtonEs = {
  [pageNameKey]: {
    chatButtonAltText: "Haz clic aquí para contactarnos",
    chatButtonText: "Contacto",
    faqButtonAltText: "Haz clic aquí para ver las preguntas frecuentes",
    faqButtonText: "Preguntas frecuentes",
    needHelp: "¿Necesitas ayuda?",
    tooltip: "Ayuda",
    weGotYou: "¡Te tenemos cubierto!",
  },
};

export const helpButtonNl = {
  [pageNameKey]: {
    chatButtonAltText: "Klik hier om contact met ons op te nemen",
    chatButtonText: "Contact",
    faqButtonAltText: "Klik hier voor de FAQ",
    faqButtonText: "FAQ",
    needHelp: "Wij staan voor u klaar!",
    tooltip: "Hulp",
    weGotYou: "Wij helpen u!",
  },
};

export const helpButtonTr = {
  [pageNameKey]: {
    chatButtonAltText: "Bizimle iletişime geçmek için buraya tıklayın",
    chatButtonText: "Temas etmek",
    faqButtonAltText: "SSS için buraya tıklayın",
    faqButtonText: "SSS",
    needHelp: "Yardıma mı ihtiyacınız var?",
    tooltip: "Yardım",
    weGotYou: "Seni yakaladık!",
  },
};
